export const LABELS = {
  assembly: {
    en: 'Assembly',
    ml: 'അസംബ്ലി'
  },
  district: {
    en: 'District',
    ml: 'ജില്ല'
  },
  state: {
    en: 'State',
    ml: 'സംസ്ഥാനം'
  },
  ward: {
    en: 'Ward',
    ml: 'വാർഡ്'
  },
  TOWN_LAT: 'lat',
  TOWN_LNG: 'lng',
  // ...add more as needed
};
